module.exports = __webpack_public_path__ + "static/media/metrocorp.788092f1.svg";